import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Login from './components/Login'
import Home from './views/Home'
import Orders from './views/Orders'
import Billings from './views/Billings'
import Customers from './views/Customers'
import CallHistory from './views/CallHistory'
import Riders from './views/Riders'
import Complaints from './views/Complaints'
import Users from './views/Users'
import Restaurants from './views/Restaurants'
import NewDeliveryOrder from './views/NewDeliveryOrder'
import ComingSoon from './views/ComingSoon'
import ViewMenu from './views/ViewMenu'
import Feedback from './views/Feedback'
import Coupons from "./views/Coupons";
import PointOfSale from './views/PointOfSale'
import Areas from './views/Areas'
import RealTimeStats from "./views/RealTimeStats"
import CustomerLocation from "./views/CustomerLocation"
import PublicOrderFeedback from "./views/PublicOrderFeedback"
import Menu from "./views/Menu";
import RestaurantBilings from "./views/RestaurantBilings"
import ViewInvoice from "./views/ViewInvoice"
import BranchOrders from "./views/BranchOrders"
import ViewPendingInvoices from "./views/ViewPendingInvoices";
import BaykedCustomers from "./views/BaykedCustomers";
import BaykedOrdersFeedback from "./views/BaykedOrdersFeedback";
import BaykedExclusiveDeals from "./views/BaykedExclusiveDeals";
import RestaurantTabView from "./views/RestaurantTabView";
import LiveStatusofBranches from "@/views/LiveStatusofBranches";
import Dashboard from "@/views/Dashboard.vue";
import BabyNames from "@/views/BabyNames.vue";
import CustomerBabies from "@/views/CustomerBabies.vue";

Vue.use(Router);

let router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: {
                notRequiredAuth: true,
                loginLayout: true,
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                role: ['ADMIN', 'USER']
            }
        },
        {
            path: '/dashboard',
            name: 'home',
            component: Dashboard,
            meta: {
                role: ['ADMIN', 'USER']
            }
        },
        {
            path: '/baby_names',
            name: 'babyNames',
            component: BabyNames,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/customer_babies',
            name: 'CustomerBabies',
            component: CustomerBabies,
            meta: {
                role: ['ADMIN', 'AGENT']
            }
        },
        {
            path: '/billings',
            name: 'billings',
            component: Billings,
            meta: {
                role: ['ADMIN']
            }
        },
        {
            path: '/branch_orders',
            name: 'branchOrders',
            component: BranchOrders,
            meta: {
                role: ['BRANCH']
            }
        },
        {
            path: '/orders',
            name: 'orders',
            component: Orders,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/customers',
            name: 'customers',
            component: Customers,
            meta: {
                role: ['ADMIN', 'AGENT', 'USER']
            }
        },
        // {
        //     path: '/riders',
        //     name: 'riders',
        //     component: Riders,
        //     meta: {
        //         role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
        //     }
        // },
        {
            path: '/complaints',
            name: 'complaints',
            component: Complaints,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/users',
            name: 'users',
            component: Users,
            meta: {
                role: ['ADMIN']
            }
        },
        {
            path: '/warehouses',
            name: 'warehouses',
            component: RestaurantTabView,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/warehouse',
            name: 'warehouse',
            component: Restaurants,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/new_delivery_order',
            name: 'NewDeliveryOrder',
            component: NewDeliveryOrder,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/coming_soon',
            name: 'ComingSoon',
            component: ComingSoon,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/view_menu',
            name: 'ViewMenu',
            component: ViewMenu,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/feedback',
            name: 'Feedback',
            component: Feedback,
            meta: {
                role: ['ADMIN', 'USER']
            }
        },
        {
            path: '/callHistory',
            name: 'CallHistory',
            component: CallHistory,
            meta: {
                role: ['ADMIN']
            }
        },
        {
            path: '/coupons',
            name: 'coupons',
            component: Coupons,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        // {
        //     path: '/point_of_sale',
        //     name: 'PointOfSale',
        //     component: PointOfSale,
        //     meta: {
        //         role: ['ADMIN', 'BRANCH']
        //     }
        // },
        {
            path: '/menu',
            name: 'BranchMenu',
            component: Menu,
            meta: {
                role: ['ADMIN', 'BRANCH']
            }
        },
        {
            path: '/areas',
            name: 'Areas',
            component: Areas,
            meta: {
                role: ['ADMIN', 'AGENT']
            }
        },
        {
            path: '/real_time_stats',
            name: 'RealTimeStats',
            component: RealTimeStats,
            redirect: '/orders',
            meta: {
                role: ['ADMIN', 'AGENT']
            }
        },
        {
            path: '/customer_location',
            name: 'CustomerLocation',
            component: CustomerLocation,
            meta: {
                notRequiredAuth: true,
                loginLayout: true,
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/order_feedback',
            name: 'PublicOrderFeedback',
            component: PublicOrderFeedback,
            meta: {
                notRequiredAuth: true,
                loginLayout: true,
                role: ['ADMIN', 'USER', 'AGENT', 'BRANCH']
            }
        },
        {
            path: '/restaurant_billings',
            name: 'RestaurantBilings',
            component: RestaurantBilings,
            meta:{
                role: ['ADMIN','USER']
            }
        },
        {
            path: '/view_invoice',
            name: 'ViewInvoice',
            component: ViewInvoice,
            meta:{
                role: ['ADMIN','USER']
            }
        },
        {
            path: '/view_pending_invoices',
            name: 'ViewPendingInvoices',
            component: ViewPendingInvoices,
            meta:{
                role: ['USER', 'ADMIN']
            }
        },
        {
            path: '/bebambi_orders_feedback',
            name: 'BaykedOrdersFeedback',
            component: BaykedOrdersFeedback,
            meta: {
                role: ['ADMIN', 'USER', 'AGENT']
            }
        },
        {
            path: '/bebambi_customers',
            name: 'BaykedCustomers',
            component: BaykedCustomers,
            meta: {
                role: ['ADMIN', 'AGENT']
            }
        },
        {
            path: '/bebambi_exclusive_deals',
            name: 'BaykedExclusiveDeals',
            component: BaykedExclusiveDeals,
            meta: {
                role: ['ADMIN']
            }
        },
        {
            path: '/live_status_of_branches',
            name: 'LiveStatusofBranches',
            component: LiveStatusofBranches,
            meta: {
                role: ['ADMIN']
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    let requiredAuth = !to.matched.some(record => record.meta.notRequiredAuth);
    let loggedInUser = store.state.status;
    if (requiredAuth && (loggedInUser === '' || loggedInUser === 'error')) {
        next("/")
    } else {
        let allowedRoles = to.meta.role;
        let loggedInUserRole = "";
        if (store.state.user.fullName !== undefined && !allowedRoles.includes(store.state.user.userRolesById[0].role.split('_')[1])) {
            loggedInUserRole = store.state.user.userRolesById[0].role.split('_')[1];
            let path;
            switch (loggedInUserRole) {
                case 'BRANCH':
                    if(store.state.user.branch.isPortalEnabled){
                        path = "/branch_orders"
                    }else {
                        path = "/point_of_sale";
                    }
                    break;
                default:
                    path = "/orders";
            }
            next(path);
        } else {
            next();
        }
    }
});


export default router;
